import { createAsyncThunk } from "@reduxjs/toolkit";
import { type EndAccessStrategy } from "@fitness-app/data-models/entities/Product";
import {
  type OneTimeProductAccessPeriod,
  type SubscriptionProductAccessPeriod,
} from "@fitness-app/data-models/entities/ProductClient";

import { type AsyncThunkCreator } from "../../../index";
import { PRODUCT_CLIENT_REDUCER } from "../types";

type Payload = {
  productId: string;
  clientEmail: string;
  updatedAccessStrategy: EndAccessStrategy;
  clientAccessPeriod: SubscriptionProductAccessPeriod | OneTimeProductAccessPeriod;
};

export const updateProductEndAccessStrategy = createAsyncThunk<void, Payload, AsyncThunkCreator<string>>(
  `${PRODUCT_CLIENT_REDUCER}/updateProductEndAccessStrategy`,
  async (payload, { rejectWithValue, extra: { db } }) => {
    // `select()` is what makes an RLS refusal visible: without it PostgREST
    // answers 204 for a row the policy filtered out, so a blocked write looks
    // exactly like a successful one (TRE-2143).
    const { data, error } = await db
      .from("product_client")
      .update({
        accessPeriod: {
          ...payload.clientAccessPeriod,
          endAccessStrategy: payload.updatedAccessStrategy,
        },
      })
      .eq("email", payload.clientEmail)
      .eq("productId", payload.productId)
      .select("id");

    if (error) {
      return rejectWithValue(error.message);
    }

    if (!data.length) {
      return rejectWithValue("No product client row was updated");
    }
  },
);
